export type OverlayRequest = {
	id: string;
	priority: number;
	requestedAt: number;
};

export const getActiveOverlayIdFromRequests = (
	overlayRequests: OverlayRequest[],
) => {
	const [activeOverlay] = [...overlayRequests].sort((a, b) => {
		if (a.priority !== b.priority) return a.priority - b.priority;

		return a.requestedAt - b.requestedAt;
	});

	return activeOverlay?.id ?? null;
};

export const upsertOverlayRequest = (
	overlayRequests: OverlayRequest[],
	nextRequest: Omit<OverlayRequest, 'requestedAt'>,
	requestedAt = Date.now(),
) => {
	const existingRequest = overlayRequests.find(
		(request) => request.id === nextRequest.id,
	);
	const overlayRequest = {
		...nextRequest,
		requestedAt: existingRequest?.requestedAt ?? requestedAt,
	};

	return existingRequest
		? overlayRequests.map((request) =>
				request.id === nextRequest.id ? overlayRequest : request,
		  )
		: [...overlayRequests, overlayRequest];
};
